import ReactModal from "react-modal";
import { nationalStatesList } from "../../lists/visitingStateLists";
import TierList from "../components/tierList";
import { useCallback, useState } from "react";

function TravelStates() {

    const [showModal, setShowModal] = useState(false);
    const handleOpenModal = useCallback((index) => {
        setShowModal(true);
    }, []);
    const handleCloseModal = useCallback((index) => {
        setShowModal(false);
    }, []);

    return (
        <>
            <div className="artwork-tape-header container">
                <div className="row">
                    <div className="col-12">
                        <div className="artwork-tape-header-titles">States</div>
                        <p className="align-center">45/50 States Visted </p>
                        <div className="gaming-tier-list-button" onClick={handleOpenModal}>
                            <div className="index-card-header">Visiting States Tier List</div>
                        </div>
                        <img className="usa-map" alt="states-traveled" src={process.env.PUBLIC_URL + "/images/experiences/UsaMap1.png"} />
                    </div>
                </div>
            </div>

            <div className="mt-5 col-12 col-md-4">
                <ReactModal
                    isOpen={showModal}
                    contentLabel="Minimal Modal Example"
                >
                    <TierList
                        title="U.S. States"
                        items={nationalStatesList}
                        tiers={["S", "A", "B", "C", "F", "NA"]}
                    />
                    <button onClick={handleCloseModal}>Close Window</button>
                </ReactModal>
            </div>
        </>
    )
}

export default TravelStates;
